import React from 'react'
import { Link } from 'react-router-dom'

function ErrorPage() {
  return (
    <section className='h-75'>
        <div className="center">
            <div className="container">
                <h1 className='h1-primary'>404 - Page Not Found</h1>
                <p className='text-dark'>Sorry, the page you are looking for does not exist.</p>
            </div>
            <div className="container">
                <button className="primary btn">
                    <Link to="/">Return to the Home</Link>
                </button>
            </div>
        </div>
    </section>
  )
}

export default ErrorPage